import type { ChronicleEventType } from '../facts';
import type { MapLink } from '../map/links';
import type { IsoDateString } from './common';

/** The sizes a photo is served in: WebP copies 480 and 1920 px wide, and the file as taken. */
export type PhotoSize = 'thumb' | 'view' | 'original';

/** The path of a photo in one size. */
export const photoUrl = (id: string, size: PhotoSize) => `/api/photos/${id}/${size}`;

/** One screenshot (M12). */
export interface PhotoInfo {
  id: string;
  takenAt: IsoDateString;
  /** Null when no Brimstone spot or session says whose it is. */
  characterId: string | null;
  characterName: string | null;
  /** The Chronicle entry it was taken of, when one happened just before. */
  event: { id: string; type: ChronicleEventType; text: string } | null;
  zone: string | null;
  subzone: string | null;
  /** The boss fight it was taken during. */
  encounter: string | null;
  /** Who or what was targeted. */
  target: string | null;
  map: MapLink | null;
  /** Null until read, or when the file couldn't be read (see `error`). */
  width: number | null;
  height: number | null;
  error: string | null;
}

/** `GET /api/photos?characterId&week&cursor&limit`: newest first. */
export interface PhotosResponse {
  photos: PhotoInfo[];
  /** Pass back as `cursor` for the next, older page; null on the last page. */
  nextCursor: string | null;
  /** Photo counts by character in the chosen week (or all time); `id` null for unknown. */
  characters: { id: string | null; name: string | null; count: number }[];
  total: number;
}
